var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.errorMessage)?_c('div',[_c('base-alert',{attrs:{"type":"danger"}},[_c('span',{staticClass:"alert-inner--text"},[_c('strong',[_vm._v(_vm._s(_vm.errorMessage))])])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }